/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Manual_Meeting_With_RemoveInputs */



/**
* | output |
* | --- |
* | "Remove {name}" |
*
* @param {Manual_Meeting_With_RemoveInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manual_meeting_with_remove = /** @type {((inputs: Manual_Meeting_With_RemoveInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Meeting_With_RemoveInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`${i?.name} verwijderen`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Retirer ${i?.name}`)
	return /** @type {LocalizedString} */ (`Remove ${i?.name}`)
});